module.exports = __webpack_public_path__ + "img/category-new-released-hover.853d9e55.png";